// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"113":"548830e2","138":"89a31f12","825":"7a891fc9","897":"17ad0db6","957":"17ad0db6"}[chunkId] + ".chunk.css";
};